import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppStore } from './store';
import { Spinner } from '@/components/ui/States';
import { toast } from '@/components/ui/Toast';

/** Gate authenticated routes. Waits for the session bootstrap, then redirects. */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const ready = useAppStore((s) => s.ready);
  const user = useAppStore((s) => s.user);
  const location = useLocation();

  if (!ready) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner label="Loading…" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

/** Gate staff-only routes, keying off user.kind. */
export function RequireStaff({ children }: { children: React.ReactNode }) {
  const user = useAppStore((s) => s.user);
  const denied = user?.kind !== 'STAFF';

  // Tell the user why they landed back home — once per denial, not per render.
  useEffect(() => {
    if (denied) toast.info('You don’t have access to that page');
  }, [denied]);

  if (denied) return <Navigate to="/" replace />;
  return <>{children}</>;
}
